<!-- @format -->

<accept-page>
  <div class="wrapper page">
    <section class="page_wrap">
      <div class="page_inner">
        <h1 class="main_title page">解析結果一覧</h1>
        <div class="history_menu">
          <div class="history_menu-number">
            <dl class="history-info">
              <dt class="history-info_heading">解析中：</dt>
              <dd class="history-info_number">
                <span class="emphasis">{ state.pending }</span>
                件
              </dd>
              <dt class="history-info_heading">未読：</dt>
              <dd class="history-info_number">
                <span class="emphasis">{ state.unread }</span>
                件
              </dd>
            </dl>
            <div class="button button_quaternary js-modal-open">
              <a class="filter" onclick="{ onOpenModal }">絞り込み</a>
            </div>
            <div class="sort_menu-container">
              <div class="sort-menu">
                <label for="sort" class="sort-menu-title">表示件数</label>
                <select
                  name="limit"
                  id="sort"
                  class="select-result"
                  onchange="{ onChangeLimit }"
                >
                  <option value="20">20件</option>
                  <option value="50">50件</option>
                  <option value="100">100件</option>
                  <option value="150">150件</option>
                  <option value="200">200件</option>
                </select>
              </div>
              <!--/.sort-menu-->
            </div>
            <!--/.sort_menu-container-->
          </div>
        </div>

        <template if="{ state.accepts && state.accepts.length == 0 }">
          <div class="ill_container">
            <img src="/assets/img/common/ill_notfound.svg" alt="" />
          </div>

          <p class="notfound_txt">
            ご指定の絞り込み条件では、該当する履歴が見つかりませんでした。
            <br />
            お手数ですが条件を変更した上で、もう一度絞り込み検索をお試しください。
          </p>
        </template>

        <template if="{ state.accepts && state.accepts.length > 0 }">
          <div class="history-list_wrap">
            <div class="history-check">
              <div class="checkbox_wrap">
                <input
                  type="checkbox"
                  name="csv-check_all"
                  value="csv-check_all"
                  id="csv-check_all"
                  class="checkbox-input"
                  onchange="{ onCheckAll }"
                />
                <label for="csv-check_all" class="checkbox-parts"></label>
                <p class="history-list_check_csv">
                  <a
                    class="dl_csv { state.checked ? 'checked' : '' }"
                    onclick="{ onDownload }"
                  >
                    選択中のチェック履歴の詳細をCSVでダウンロード
                  </a>
                </p>
              </div>
              <!--/.checkbox_wrap-->
            </div>
            <!--/.history-check-->

            <div
              each="{ (accept, i) in state.accepts }"
              class="history-list { accept.result.status == 1 ? 'under-analysis' : '' } { accept.result.status == 2 && accept.result.unread == 1 ? 'unread' : '' }"
            >
              <div class="history-list_check-container">
                <p class="history-list_check">
                  <input
                    type="checkbox"
                    name="csv-check"
                    id="csv-check-{ i }"
                    class="checkbox-input"
                    checked="{ accept.checked }"
                    onchange="{ e => onCheck(e, i) }"
                  />
                  <label
                    for="csv-check-{ i }"
                    class="checkbox-parts history-list_check"
                  ></label>
                </p>
              </div>
              <!--/.history-list_check-container-->
              <a
                href="{ routes.makePath('items-page', { analyticId: accept.result['id'] }) }"
                class="history-anchor"
                onclick="{ e => onClickItem(e, accept) }"
              >
                <div class="history-list_contents">
                  <div class="history-list_info">
                    <div class="history-list_info-icn_wrap">
                      <div class="history-list_info-icn duplication">重複</div>
                      <div
                        if="{ accept.result.type==2 }"
                        class="history-list_info-icn similar"
                      >
                        類似
                      </div>
                    </div>
                    <!--/.history-list_info-icn_wrap-->
                    <div class="history-list_info-box">
                      <dl
                        class="history-info"
                        each="{ data in [accept.result] }"
                      >
                        <dt class="history-info_heading">解析日時：</dt>
                        <dd class="history-info_number">{ data.created }</dd>
                        <dt class="history-info_heading">文字数：</dt>
                        <dd class="history-info_number">{ data.length }</dd>
                        <dt class="history-info_heading">消費カウント：</dt>
                        <dd class="history-info_number">{ data.ticket }</dd>
                        <dt class="history-info_heading">履歴ID：</dt>
                        <dd class="history-info_number">{ data.id }</dd>
                        <template if="{ data.status==2 }">
                          <dt class="history-info_heading">最高一致文字数：</dt>
                          <dd class="history-info_number">
                            <span class="emphasis">
                              { data.duplication_length }
                            </span>
                          </dd>
                          <dt class="history-info_heading">最大一致率：</dt>
                          <dd class="history-info_number">
                            <emphasized-value
                              ratio="{ data.duplication_ratio }"
                            ></emphasized-value>
                          </dd>
                          <dt class="history-info_heading">総合類似度：</dt>
                          <dd class="history-info_number">
                            <emphasized-value
                              if="{ accept.result.type == 1 }"
                              value="-"
                            ></emphasized-value>
                            <emphasized-value
                              if="{ accept.result.type == 2 }"
                              ratio="{ data.total }"
                            ></emphasized-value>
                          </dd>
                        </template>
                      </dl>
                    </div>
                    <!--/.history-list_info-box-->
                  </div>
                  <!--/.history-list_info-->

                  <div class="history-list_txt">
                    { accept.result.summary.substr(0, 151) }
                  </div>
                </div>
                <!--/.history-list_contents-->
                <div class="history-list_arow"></div>
              </a>
              <!--/.history-anchor-->
            </div>
            <!--/.history-list-->
          </div>
          <!--/.history-list_wrap-->

          <template if="{ state.pager.total > 0 }">
            <pager
              pager="{ state.pager }"
              on-pager="{ onPager }"
              max-pages="5"
            ></pager>
          </template>
        </template>
      </div>
      <!--/.page_inner-->
    </section>
    <!--page_wrap-->
  </div>
  <!--/.wrapper-->

  <accept-modal
    status="{ state.modalStatus }"
    param="{ state.searchParam }"
    on-close="{ onCloseModal }"
    on-confirm="{ onConfirm }"
  ></accept-modal>

  <script>
    import di from "dependeny-injection";
    import routes from "@model/routes.js";
    import pager from "@tags/parts/pager.riot";
    import acceptModal from "@tags/modal/accept-modal.riot";
    import {
      AcceptService,
      api as AcceptApi,
      SearchParam,
    } from "@model/accept.js";

    export default {
      components: {
        pager,
        "accept-modal": acceptModal,
      },
      onBeforeMount() {
        this.routes = routes;
        this.state = {
          status: {
            proccessingCount: 0,
            unreadCount: 0,
          },
          modalStatus: false,
          searchParam: new SearchParam(),
          pager: {},
          accepts: null,
          checked: false,
        };
        di.userStatusApi.on("fetched", (data) => {
          this.update();
        });
      },
      onMounted(props, state) {
        const page = props.routeParams[0];
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        for (const [key, value] of params.entries()) {
          this.state.searchParam[key] = value;
        }
        this.$('select[name="limit"]').value = this.state.searchParam.limit;
        this.onChangePage({}, page ? page : 1);
      },
      shouldUpdate(newProps, currentProps) {
        if (newProps.routeParams[0] != currentProps.routeParams[0]) {
          if (!newProps.routeParams[0]) {
            this.state.searchParam = new SearchParam();
            this.$('select[name="limit"]').value = this.state.searchParam.limit;
            this.onChangePage({}, 1);
          }
        }
      },
      onPager(e, page) {
        di.router.push(
          this.routes.makePath("accept-page", { page }) +
            `?${this.state.searchParam.getQuery()}`
        );
        this.onChangePage(e, page ? page : 1);
      },
      onChangeLimit(e) {
        this.state.searchParam.limit = e.target.value;
        this.onPager({}, 1);
      },
      async onChangePage(e, page) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

        di.loader.setState(true);
        const res = await AcceptApi.requestAcceptHistories(
          page,
          this.state.searchParam.limit,
          this.state.searchParam.start_date,
          this.state.searchParam.end_date,
          this.state.searchParam.min_length,
          this.state.searchParam.min_ratio,
          this.state.searchParam.similarity
        );
        if (res && res.success) {
          this.state.pager = res.pager;
          this.state.pending = res.pending;
          this.state.unread = res.unread;
          this.state.accepts = AcceptService.genAccepts(res.pager.items);
        } else {
          di.toast.push(
            res && res.msg ? res.msg : "エラーが発生しました。",
            "negative"
          );
        }
        di.loader.setState(false);

        if (this.$("#csv-check_all")) {
          this.$("#csv-check_all").checked = false;
          this.state.checked = false;
        }
        this.update();
      },
      onOpenModal(e) {
        this.update({ modalStatus: true });
      },
      onCloseModal(e) {
        this.update({ modalStatus: false });
      },
      onConfirm(searchParam) {
        this.state.searchParam = searchParam.clone();
        this.update({ modalStatus: false });
        this.onPager({}, 1);
      },
      onCheck(e, i) {
        this.state.accepts[i].checked = e.target.checked;
        this.update({
          checked: this.state.accepts.reduce((a, c) => {
            return a || c.checked;
          }, false),
        });
      },
      onCheckAll(e) {
        for (const accept of this.state.accepts) {
          accept.checked = e.target.checked && accept.result.status == 2;
        }
        this.update({
          checked: this.state.accepts.reduce((a, c) => {
            return a || c.checked;
          }, false),
        });
      },
      onClickItem(e, accept) {
        if (accept.result.status != 2) {
          e.preventDefault();
        }
      },
      onDownload(e) {
        if (!this.state.checked) {
          return;
        }
        const dupIds = this.state.accepts.reduce((a, c) => {
          if (c.checked) {
            a.push(c.result.id);
          }
          return a;
        }, []);
        const simIds = this.state.accepts.reduce((a, c) => {
          if (c.checked && c.result.type == 2) {
            a.push(c.result.id);
          }
          return a;
        }, []);
        const download = (path, ids, name) => {
          let a = document.createElement("a");
          a.download = name;
          a.target = "_blank";
          a.href = path + "?ids=" + encodeURIComponent(JSON.stringify(dupIds));
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        if (dupIds.length > 0) {
          download("/download/kagemusya/", dupIds, "duplication.csv");
        }
        if (simIds.length > 0) {
          download("/download/similarity/", simIds, "similarity.csv");
        }
      },
    };
  </script>
</accept-page>
